import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useLocation } from "react-router-dom";
import Layout from "@/_LayoutsRelated/layout/Layout";
import PostViewMain from "@/pages/post/PostViewMain";
import useApi from "@hooks/useApi";
import { api__getNewPostViewData } from "@/apis/posts/getNewPostViewData";
import Loader from "@componentsShared/Loader/Loader";
import { useEffect } from "react";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
import { extractPostId } from "../post/helpers/postHelpers";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import useFullLoading from "@hooks/useFullLoading";
var CarInfo = function CarInfo() {
  var _postDetails$details, _location$state;
  var location = useLocation();
  var postId = extractPostId(location.pathname);
  var _usePostDetails = usePostDetails(),
    setPostDetails = _usePostDetails.setPostDetails;
  var postViewApiResponseFullPageData = useFullPageData();
  var _useApi = useApi([postId], function () {
      return api__getNewPostViewData(postId, null, [], 0);
    }, null, postViewApiResponseFullPageData === null || postViewApiResponseFullPageData === void 0 ? void 0 : postViewApiResponseFullPageData.postDetails),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    postDetails = _useApi2[2];
  var fullPageLoading = useFullLoading();
  useEffect(function () {
    setPostDetails(postDetails);
    return function () {
      setPostDetails(null);
    };
  }, [postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details = postDetails.details) === null || _postDetails$details === void 0 ? void 0 : _postDetails$details.id]);
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    headHideLinks: true,
    disableLoader: true,
    authenticationMsg: true,
    tracking: true //enable for showing tracking with back header
  }, (fullPageLoading || loading) && /*#__PURE__*/React.createElement(Loader, null), !loading && /*#__PURE__*/React.createElement(PostViewMain, {
    isTrackingView: true,
    financeView: true,
    loading: loading,
    screen_view_referral: location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.screen_view_referral
  }));
};
export default CarInfo;